import axios from '../../../axios';
import EmailLogPayload from '../types/EmailLogPayload';

export const getSentEmailLogs = (payload: EmailLogPayload) =>
  axios.post('emailingapp/api/emailing/_search/log-filter', payload);

export const getEmailLogsForCandidate = (candidateId: string) =>
  axios.get(`candidatesearch/api/get-email-log/${candidateId}`);

export const getIndividualEmailLogs = (candidateEmail: string) =>
  axios.post('emailingapp/api/emailing/_search', candidateEmail);

export const getCampaignEmailLogs = () =>
  axios.get('candidatesearch/api/bulk-email-scheduling/recent-top50-campaigns');

export const getInboxLoadFirstTime = (email: string, seen: string) =>
  axios.get(`emailingapp/api/email/fetch?email=${email}&seen=${seen}`);

export const getInboxPaginated = (email: string, pageNo: number, seen: string) =>
  axios.get(`emailingapp/api/email/fetch?email=${email}&pageNo=${pageNo}&seen=${seen}`);

export const getInboxEmailBody = (email: string, messageId: string) =>
  axios.get(`emailingapp/api/email/body`, { params: { email: email, messageId: messageId } });

export const getInboxEmailAttachment = (email: string, messageId: string, uuid: string) =>
  axios({
    url: `emailingapp/api/email/download/attachment`,
    method: 'GET',
    responseType: 'arraybuffer',
    params: { email: email, messageId: messageId, uuid: uuid },
  });

export const poolingForEmails = (email: string) =>
  axios.get(`emailingapp/api/polling/add?email=${email}`);

export const checkForNewEmails = (email: string) =>
  axios.get(`emailingapp/api/email/new?email=${email}`);

export const validatingImapConfiguration = (email: string) =>
  axios.get(`emailingapp/api/email/connectivity?email=${email}`);

export const getEmailStatistics = (email: string) =>
  axios.get(`emailingapp/api/email/statistics?email=${email}`);

export const getPreviewForEmailBody = (s3url: string) =>
  axios.get('emailingapp/api/get-email-body-preview', { params: { s3Url: s3url } });

export const downloadAttachmentForSearch = (url: string, email: string) =>
  axios.get(`emailingapp/api/download-attachment?url=${url}&email=${email}`, {
    responseType: 'blob',
  });

export const searchImap = (query: string, email: string) =>
  axios.get(`/emailingapp/api/search-email?query=${query}&email=${email}`);
